import React, { useState, useEffect } from 'react';
import { useAdmin } from '../../context/AdminContext';
import axios from 'axios';
import toast from 'react-hot-toast';
import { Eye } from 'lucide-react';
import { ADMIN_BASE } from '../../utils/apiBase';

const API = ADMIN_BASE;

const AdminCustomers = () => {
  const { getAuthHeader } = useAdmin();
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [customerOrders, setCustomerOrders] = useState([]);

  useEffect(() => {
    fetchCustomers();
  }, []);

  const fetchCustomers = async () => {
    try {
      const res = await axios.get(`${API}/customers`, { headers: getAuthHeader() });
      setCustomers(res.data);
    } catch (error) {
      toast.error('Failed to fetch customers');
    }
  };

  const viewCustomerDetails = async (customerEmail) => {
    try {
      const customer = customers.find(c => c.email === customerEmail);
      setSelectedCustomer(customer);
      
      const res = await axios.get(`${API}/customers/${customerEmail}/orders`, {
        headers: getAuthHeader()
      });
      setCustomerOrders(res.data);
    } catch (error) {
      toast.error('Failed to load customer details');
    }
  };

  return (
    <div>
      <h1 className="text-3xl font-bold text-gray-800 mb-6">Customers</h1>

      {selectedCustomer && (
        <div className="bg-white rounded-lg shadow p-6 mb-6">
          <div className="flex justify-between items-start mb-4">
            <div>
              <h2 className="text-2xl font-bold">{selectedCustomer.name}</h2>
              <p className="text-gray-600">{selectedCustomer.email}</p>
            </div>
            <button
              onClick={() => { setSelectedCustomer(null); setCustomerOrders([]); }}
              className="text-gray-600 hover:text-gray-800"
            >
              Close
            </button>
          </div>

          <div className="grid grid-cols-3 gap-4 mb-6">
            <div className="bg-gray-50 p-4 rounded-lg">
              <p className="text-sm text-gray-600">Total Orders</p>
              <p className="text-2xl font-bold">{selectedCustomer.total_orders}</p>
            </div>
            <div className="bg-gray-50 p-4 rounded-lg">
              <p className="text-sm text-gray-600">Total Spent</p>
              <p className="text-2xl font-bold">₹{selectedCustomer.total_spent.toFixed(2)}</p>
            </div>
            <div className="bg-gray-50 p-4 rounded-lg">
              <p className="text-sm text-gray-600">Phone</p>
              <p className="text-lg font-semibold">{selectedCustomer.phone}</p>
            </div>
          </div>

          <h3 className="font-bold mb-4">Order History</h3>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-2 text-left">Order ID</th>
                  <th className="px-4 py-2 text-left">Date</th>
                  <th className="px-4 py-2 text-left">Total</th>
                  <th className="px-4 py-2 text-left">Status</th>
                </tr>
              </thead>
              <tbody>
                {customerOrders.map((order) => (
                  <tr key={order.id} className="border-t">
                    <td className="px-4 py-2">{order.id.slice(0, 8)}</td>
                    <td className="px-4 py-2">{new Date(order.created_at).toLocaleDateString()}</td>
                    <td className="px-4 py-2">₹{order.total}</td>
                    <td className="px-4 py-2">
                      <span className="px-2 py-1 bg-green-100 text-green-800 rounded text-sm">
                        {order.payment_status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      <div className="bg-white rounded-lg shadow overflow-hidden">
        <table className="w-full">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3 text-left">Name</th>
              <th className="px-4 py-3 text-left">Email</th>
              <th className="px-4 py-3 text-left">Phone</th>
              <th className="px-4 py-3 text-left">Total Orders</th>
              <th className="px-4 py-3 text-left">Total Spent</th>
              <th className="px-4 py-3 text-left">Actions</th>
            </tr>
          </thead>
          <tbody>
            {customers.map((customer) => (
              <tr key={customer.email} className="border-t">
                <td className="px-4 py-3">{customer.name}</td>
                <td className="px-4 py-3">{customer.email}</td>
                <td className="px-4 py-3">{customer.phone}</td>
                <td className="px-4 py-3">{customer.total_orders}</td>
                <td className="px-4 py-3">₹{customer.total_spent.toFixed(2)}</td>
                <td className="px-4 py-3">
                  <button
                    onClick={() => viewCustomerDetails(customer.email)}
                    className="text-blue-600 hover:text-blue-800"
                  >
                    <Eye size={18} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminCustomers;
